import React from 'react';
import { useTranslation } from 'react-i18next';
import useKeepitalRoutes from '../_hook/useKeepitalRoutes';
import { IProductSchema } from '../../../graphql/type/product';
import useCurrency from '../_hook/useCurrency';

interface IProps {
  product: IProductSchema;
  variationId?: string;
  redRfq?: boolean;
}

export default function SchemaProductPrice(props: IProps) {
  const { product, variationId, redRfq } = props;
  const { exchange } = useCurrency();
  const { t } = useTranslation();

  if (variationId) {
    const variations = product.variations || [];
    const variation = variations.find(
      (tempVariation) => tempVariation.id === variationId
    );

    return (
      <>
        {product.prices &&
        product.prices.currency &&
        variation &&
        variation.attributes &&
        variation.attributes.prices !== 0 ? (
          <> {exchange(variation.attributes.prices, product.prices.currency)}</>
        ) : (
          <>
            {redRfq ? (
              <span
                style={{ color: 'red  ' }}
                data-toggle="tooltip"
                title={t('request_for_quote')}
              >
                {t('rfq')}
              </span>
            ) : (
              t('rfq')
            )}
          </>
        )}
      </>
    );
  }

  return (
    <>
      {product.prices.currency &&
      product.prices &&
      product.prices.final !== 0 ? (
        <> {exchange(product.prices.final, product.prices.currency)}</>
      ) : (
        <>
          {redRfq ? (
            <span
              style={{ color: 'red  ' }}
              data-toggle="tooltip"
              title={t('request_for_quote')}
            >
              {t('rfq')}
            </span>
          ) : (
            t('rfq')
          )}
        </>
      )}
    </>
  );
}
